import { useSchedulingIndex } from 'app/components/scheduling-index/useSchedulingIndex'
import {
  SchedulingIndexShadcnComponent,
  getSchedulingShadcnColumns,
} from 'app/components/scheduling-index/SchedulingIndexShadcnComponent'

export default function SchedulingIndex(): React.ReactElement {
  const { locations, columns } = useSchedulingIndex(getSchedulingShadcnColumns)

  return <SchedulingIndexShadcnComponent locations={locations} columns={columns} />
}
